import { portalCustomizationZodSchema } from "@redotech/redo-customer-portal-common/portal-customization";
import * as z from "zod";

export const getPortalCustomization = {
  name: "getPortalCustomization" as const,
  input: z.object({}),
  output: z.object({
    customization: portalCustomizationZodSchema.nullable(),
    // Retained for compatibility with cached clients deployed before migration.
    portalBuilderMigrated: z.literal(true),
  }),
};

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export {
  portalCustomizationZodSchema,
  type PortalCustomization,
} from "@redotech/redo-customer-portal-common/portal-customization";
